import i18n from 'i18n';
import { UNKNOWN_ICON } from './categories';
import { Category, CategoryDTO, Icon } from './ducks/types';

export const getCategoryName = (category: Category, language?: 'fr' | 'en') => {
  const lang = language || i18n.language;
  return lang === 'fr' ? category.name_fr : category.name_en;
};

export const getIcon = (category?: CategoryDTO): Icon => {
  if (category) {
    const icon: Icon = { source: category.icon_source, name: category.icon_name };
    return icon;
  }
  return UNKNOWN_ICON;
};
